import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/bluetooth': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M292.6 171.1l-42.9 42.9-0.3-86zM249.4 390.9l0.2-86 42.9 42.9zM416 259.4c0 205.6-71.9 252.6-185.1 252.6-113.2 0-198.9-47-198.9-252.6 0-205.6 83.4-259.4 196.6-259.4 113.2 0 187.4 53.9 187.4 259.4zM257.5 259.4l79.4-88.6-125.1-134.3v176.9l-73.8-73.8-27 26.9 92.7 93-92.7 93 26.9 26.9 73.8-73.8 2.3 170 127.4-127.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/bluetooth.js
// module id = 733
// module chunks = 0